import { useState } from 'react'
import { Trans } from 'react-i18next'
import { t } from 'i18next'

import { Date16, Refresh16 } from '@makyoapp/makyo-icon/icon'
import { Button, ButtonVariant, Modal, SingleDatePicker } from '@makyoapp/makyo-ui'

import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'

const DatePickerFieldSetting = ({ id, value }: { id: string; value: any }) => {
  const [showDate, setShowDate] = useState(false)
  const [selDate, setSelDate] = useState(new Date())
  const updateValue = useUpdateCompSettingValue(id)

  return (
    <div className='inline-flex items-center'>
      <Button
        variant={ButtonVariant.Ghost}
        onClick={() => {
          setShowDate(true)
        }}
        squared={!Boolean(value)}
        noPadding={!Boolean(value)}
        icon={<Date16 className='shrink-0' />}
      >
        {value && value instanceof Date ? value.toDateString() : null}
      </Button>
      {value && value instanceof Date && (
        <Button
          squared
          noPadding
          variant={ButtonVariant.Ghost}
          title={t('Clear')}
          onClick={async () => {
            await updateValue(undefined)
          }}
        >
          <Refresh16 />
        </Button>
      )}
      <Modal
        show={showDate}
        onHide={() => {
          setShowDate(false)
        }}
      >
        <Modal.Body noPadding>
          <SingleDatePicker
            className='text-m-m'
            onDateSelected={(v) => {
              setSelDate(v.date)
            }}
            selected={value && value instanceof Date ? value : selDate}
          />
        </Modal.Body>
        <Modal.Footer className='justify-between'>
          <Button
            variant={ButtonVariant.Outlined}
            onClick={() => {
              setShowDate(false)
              setSelDate(new Date())
            }}
          >
            <Trans>Cancel</Trans>
          </Button>
          <Button
            onClick={async () => {
              setShowDate(false)
              await updateValue(selDate)
            }}
          >
            <Trans>Done</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default DatePickerFieldSetting
